import { useState, memo, FC } from 'react'

import Anchor from '@/elements/anchor/Anchor'
import NavPanel from '@/components/Header/components/NavPanel'
import CookiesConsentPopup from '@/components/Header/components/HeaderExtensions/CookiesConsentPopup'
import AuthControl from '@/components/Header/components/AuthControl'
import MobileMenu from '@/components/Header/components/Menu/MobileMenu'
import BuyCrypto from '@/components/Header/components/BuyCrypto'
import Image from 'next/image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import sendEmail from '@/src/services/redirect/sendEmail'
import styled from '@emotion/styled'
import MobileMenuNew from '@/components/Header/components/Menu/MobileMenuNew'
import { HeaderContainer, NavControlPanelHeader } from './styles/NavControlPanelHeader'
import { MobileMenuButton, LogoContainer } from './styles/Indicators.styles'
import { NavActionsContainer } from './styles/Navigation.styles'
import GradientButton from '../elements/button/GradientButton'
import { EButtonStyleVariantClass } from '../elements/button/Button'

const MobileButtonContainer = styled.div`
    display: none;

    @media (max-width: ${props => props.theme.bps.md}) {
        display: block;
        margin-left: auto;
    }
`

const PageHeader: FC = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    const handleClickMobileMenu = () => setShowMobileMenu(prevState => !prevState)

    return (
        <HeaderContainer>
            <NavControlPanelHeader>
                <LogoContainer>
                    <Image
                        src="/images/easywallet/logo-easywallet.png"
                        alt="easywallet logo"
                        width={160}
                        height={32}
                        loading="eager"
                    />
                </LogoContainer>
                <NavActionsContainer>
                    <NavPanel />
                </NavActionsContainer>
                <MobileButtonContainer>
                    <MobileMenuNew isOpen={showMobileMenu} onToggle={handleClickMobileMenu} />
                </MobileButtonContainer>
            </NavControlPanelHeader>

            <CookiesConsentPopup />
        </HeaderContainer>
    )
}

export default memo(PageHeader)
